import { useEffect, useState } from "react";
import ChapterPreview from "./chapter/ChapterPreview" 
import ChaptersList from "./chapter/ChaptersList" 
import useIsMobile from "../../hooks/isMobile";

export default function DashboardTrackSummary({track, matchType, enrollment, onItemCompleted}) {

    const [selectedChapter, setSelectedChapter] = useState(undefined)
    const isTablet = useIsMobile(1350)
    const isMobile = useIsMobile(900)

    const onChapterClick = (chapter) => {
        setSelectedChapter(undefined)
        setTimeout(() => setSelectedChapter(chapter), 5);
    }

    useEffect(() => {
        if (!track?.chapters) return
        if (selectedChapter) {
            const id = selectedChapter.id
            const chapter = track.chapters.find(it => it.id == id)
            setSelectedChapter(chapter)
        } else {
            const chapter = track.chapters.find(it => !it.isCompleted && !it.isLocked)
            if (chapter) onChapterClick(chapter)
        }
    }, [track])

    return(<div>
        <div className="grid gap-3xl" style={{gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1.25fr 2fr' : '0.75fr 2fr'}}>
            <ChaptersList trackName={track?.name} chapters={track?.chapters} enrolledAt={enrollment?.enrolledAt ?? ''} matchId={enrollment?.matchProposal?.id} nextUnlocksDays={enrollment?.currentChapterDaysLeft} onClick={onChapterClick} selected={selectedChapter}/>
            <ChapterPreview chapter={selectedChapter} enrollmentId={enrollment?.id} matchType={matchType} onItemCompleted={onItemCompleted}/>
        </div>
    </div>)
}